var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.photo !== null)?_c('div',{staticClass:"plugin-stores-photo",style:(_vm.imageStyle)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }